export default __webpack_public_path__ + "static/media/aaron-paul-thandiwe-newton_0.2ba38c0a.jpg";